import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from '@lux/components';
import {
  FormControlLabel,
  Radio as MuiRadio,
  withStyles
} from '@material-ui/core';
import { noop } from '@lux/helpers';
import theme from '../../theme';

import { H5, SubtitleSecondary } from '../Base';
import Spacing from '../Spacing';
import useTranslate from '../../hooks/useTranslation';

const Radio = withStyles({
  root: {
    color: theme.colours.grey_400,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    marginRight: theme.spacing(0.5),
    '&$checked': {
      color: theme.colours.link
    }
  },
  checked: {}
})(MuiRadio);

const PhoneMonthSelection = ({
  months,
  onMonthChange = noop,
  selectedMonth
}) => {
  const { t } = useTranslate();
  return (
    <Fragment>
      <Spacing bottom={1.5}>
        <H5>{t('SINGTEL_PAY_LATER_ZERO_INSTEREST_INSTALMENT_PLAN')}</H5>
      </Spacing>
      <Row>
        {months.map(month => (
          <Column key={month} sm={6} lg={4}>
            <FormControlLabel
              control={
                <Radio
                  type="radio"
                  id={`${month}-months`}
                  checked={selectedMonth === month}
                  color="default"
                  name="radio-monthly-term"
                  value={month}
                  onChange={() => onMonthChange(month)}
                  inputProps={{ 'data-testid': `${month}-months` }}
                />
              }
              label={<SubtitleSecondary>{`${month} months`}</SubtitleSecondary>}
            />
          </Column>
        ))}
      </Row>
    </Fragment>
  );
};

PhoneMonthSelection.propTypes = {
  /** Set the array of monthly terms to render */
  months: PropTypes.array,
  /** Set the event when the selected month change */
  onMonthChange: PropTypes.func,
  /** Set the selected month */
  selectedMonth: PropTypes.string
};

export default PhoneMonthSelection;
